/* Basko — Días hábiles y feriados de Chile.
 *
 * ÚNICA FUENTE DE VERDAD. La consumen:
 *   - PDP / carrito / drawer: fecha dinámica -> [data-bk-ship-date]
 *   - PDP / carrito / drawer: qué frase se lee, y el badge "LLEGA HOY" de las
 *     tarjetas                              -> html.bk-ttechday
 *
 * Los feriados móviles de 2027 (Semana Santa, San Pedro y San Pablo, Pueblos
 * Indígenas, Encuentro Dos Mundos, Iglesias Evangélicas) son estimados.
 * Revisar contra el decreto oficial antes de que empiece el año.
 */
(function (w, d) {
  var HOLIDAYS = new Set([
    // 2026
    '2026-01-01','2026-04-03','2026-04-04','2026-05-01','2026-05-21',
    '2026-06-21','2026-06-29','2026-07-16','2026-08-15','2026-09-18',
    '2026-09-19','2026-10-12','2026-10-31','2026-11-01','2026-12-08','2026-12-25',
    // 2027
    '2027-01-01','2027-03-26','2027-03-27','2027-05-01','2027-05-21',
    '2027-06-21','2027-06-28','2027-07-16','2027-08-15','2027-09-18',
    '2027-09-19','2027-10-11','2027-10-31','2027-11-01','2027-12-08','2027-12-25'
  ]);
  var DAYS = ['domingo','lunes','martes','miércoles','jueves','viernes','sábado'];
  var TZ = 'America/Santiago';
  // Un solo corte público: 13:00, Baskoexpress, 36 comunas de Santiago.
  //
  // @deprecated CUTOFF_HOUR (11:00) era el corte de Global Express, que sigue
  // existiendo en la operación para la RM fuera de las 36 comunas pero ya no se
  // promete en el sitio. SIN CONSUMIDORES: se deja publicado en w.BKDia junto
  // con inSameDayWindow() por si vuelve a comunicarse ese canal. Si aparece un
  // consumidor nuevo, revisar primero si de verdad se quiere prometer 11:00.
  var CUTOFF_HOUR = 11;
  var CUTOFF_HOUR_TTECH = 13;

  function nowParts() {
    var parts = {};
    new Intl.DateTimeFormat('en-CA', {
      timeZone: TZ,
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', hour12: false
    }).formatToParts(new Date()).forEach(function (p) { parts[p.type] = p.value; });
    return {
      iso: parts.year + '-' + parts.month + '-' + parts.day,
      hour: parseInt(parts.hour, 10)
    };
  }
  // Mediodía UTC evita que el offset de Chile corra el día.
  function isoToDate(iso) {
    var p = iso.split('-');
    return new Date(Date.UTC(+p[0], +p[1] - 1, +p[2], 12, 0, 0));
  }
  function dateToIso(dt) {
    return dt.getUTCFullYear() + '-' +
      String(dt.getUTCMonth() + 1).padStart(2, '0') + '-' +
      String(dt.getUTCDate()).padStart(2, '0');
  }
  function isBusinessDay(iso) {
    var dow = isoToDate(iso).getUTCDay();
    if (dow === 0 || dow === 6) return false;
    return !HOLIDAYS.has(iso);
  }
  function addDays(iso, n) {
    var dt = isoToDate(iso);
    dt.setUTCDate(dt.getUTCDate() + n);
    return dateToIso(dt);
  }
  function nextBusinessDay(iso) {
    var next = addDays(iso, 1);
    while (!isBusinessDay(next)) next = addDays(next, 1);
    return next;
  }
  // Ventana de despacho el mismo día: antes del cutoff Y en día hábil.
  function inWindow(cutoff) {
    var now = nowParts();
    return now.hour < cutoff && isBusinessDay(now.iso);
  }
  // @deprecated junto con CUTOFF_HOUR. Nadie la llama hoy.
  function inSameDayWindow() { return inWindow(CUTOFF_HOUR); }
  function inTTechWindow() { return inWindow(CUTOFF_HOUR_TTECH); }

  w.BKDia = {
    nowParts: nowParts,
    isBusinessDay: isBusinessDay,
    nextBusinessDay: nextBusinessDay,
    addDays: addDays,
    inSameDayWindow: inSameDayWindow,
    inTTechWindow: inTTechWindow,
    CUTOFF_HOUR: CUTOFF_HOUR,
    CUTOFF_HOUR_TTECH: CUTOFF_HOUR_TTECH
  };

  // 'HOY' | 'MAÑANA JUEVES 30' | 'EL LUNES 2', según el cutoff del canal.
  function shipLabel(cutoff) {
    var now = nowParts();
    var target = inWindow(cutoff) ? now.iso : nextBusinessDay(now.iso);
    if (target === now.iso) return 'HOY';
    var dt = isoToDate(target);
    var etiqueta = DAYS[dt.getUTCDay()] + ' ' + dt.getUTCDate();
    return (target === addDays(now.iso, 1) ? 'MAÑANA ' + etiqueta : 'EL ' + etiqueta).toUpperCase();
  }

  // Todos los marcadores usan el único corte público (13:00). El atributo ya
  // no elige canal: se conserva el valor "ttech" en el markup porque renombrar
  // los identificadores internos está postergado, pero acá da lo mismo.
  function paintShipDate() {
    var els = d.querySelectorAll('[data-bk-ship-date]');
    if (!els.length) return;
    var label = shipLabel(CUTOFF_HOUR_TTECH);
    els.forEach(function (el) { el.textContent = label; });
  }

  // Clase en <html>, no en cada badge: el load-more del catálogo inyecta
  // tarjetas por fetch después de este script y heredan el estado igual.
  function paintBadges() {
    d.documentElement.classList.toggle('bk-ttechday', inTTechWindow());
  }

  function run() {
    // Sin la tabla de feriados actualizada preferimos no prometer nada:
    // la PDP mantiene su fallback SSR y los badges quedan ocultos.
    try { paintShipDate(); paintBadges(); } catch (e) {}
  }

  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', run);
  else run();
})(window, document);
